<template>
  <div>
    <table-header
      :title="'Prowizje użytkowników'"
      :withPagination="true"
      :dispatchAction="'fetchUsersWithTheirCommisions'"
      :onPage="this.users.on_page"
      :pageNumber="this.users.page_number"
      :total="this.users.total_value"
      :downloadAction="true"
      :refreshAction="true"
      :tableName="'userCommisions'"
    ></table-header>

    <table class="table borderless table-striped table-sm">
      <thead>
        <tr class="tr-table">
          <th scope="col">ID użytkownika</th>
          <th scope="col">Numer tel.</th>
          <th scope="col">Imię</th>
          <th scope="col">Nazwisko</th>
          <th scope="col">Data urodzenia</th>
          <th scope="col">Pesel</th>
          <th scope="col">Zdjęcie</th>
          <th scope="col">Aktualna prowizja</th>
          <th scope="col">Prowizja okresowa</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users.profiles" :key="user.id">
          <td>{{ user.user.id }}</td>
          <td>{{ user.user.phone }}</td>
          <td>{{ user.profile.first_name }}</td>
          <td>{{ user.profile.last_name }}</td>
          <td>
            {{
              user.profile.birthdate
                ? formattedDateWithoutTime(user.profile.birthdate)
                : "Brak"
            }}
          </td>
          <td>{{ user.profile.pesel ? user.profile.pesel : "Brak" }}</td>
          <td>
            <a
              target="_blank"
              :href="getUrl() + '/api/profile/photo/' + user.profile.file_path"
            >
              <img
                class="img-avatar"
                :src="getUrl() + '/api/profile/photo/' + user.profile.file_path"
              />
            </a>
          </td>
          <td style="position: relative">
            {{
              user.user.commission
                ? `${Math.round(user.user.commission * 100 * 100) / 100}%`
                : "Brak"
            }}
            <span v-if="user.user.commission_valid_date">
              do
              {{ formattedDateWithoutTime(user.user.commission_valid_date) }}
            </span>
            <div class="currentCommission">
              <button
                type="button"
                class="btn btn-sm btn-outline-dark"
                data-toggle="modal"
                data-target="#editCurrentCommission"
                @click="
                  setUserCurrentCommissionData(
                    user.user.id,
                    user.user.commission,
                    user.user.commission_valid_date
                  )
                "
              >
                {{ user.user.commission ? `Zmień` : `Dodaj` }}
              </button>
            </div>
          </td>
          <td>
            <div v-if="user.user.is_periodic_commission">
              {{
                user.user.periodic_commission_value
                  ? `od ${formattedDateWithoutTime(
                      user.user.commission_start
                    )} do ${formattedDateWithoutTime(
                      user.user.commission_stop
                    )}`
                  : "Brak"
              }}
              <br />
              Prowizja:
              {{
                user.user.periodic_commission_value
                  ? `${user.user.periodic_commission_value * 100}%`
                  : "Brak"
              }}
            </div>
            <div v-else>Brak</div>

            <div class="periodicCommission">
              <button
                type="button"
                class="btn btn-sm btn-outline-dark"
                data-toggle="modal"
                data-target="#editCommission"
                @click="
                  setUserCommissionData(
                    user.user.id,
                    user.user.periodic_commission_value,
                    user.user.commission_start,
                    user.user.commission_stop
                  )
                "
              >
                {{ user.user.is_periodic_commission ? `Zmień` : `Dodaj` }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="modal fade"
      id="editCommission"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editCommission"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editCommission">
              Prowizja na dany okres
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit.prevent="editUserCommission()">
              <div class="input-container">
                <label>Wartość prowizji</label>
                <input
                  v-model.number="userCommission"
                  id="userCommission"
                  type="number"
                  class="form-control"
                  required
                  minlength="1"
                  placeholder="0.00"
                  step="0.01"
                  max="1"
                  min="0"
                />
              </div>
              <div class="input-container">
                <label>Od kiedy ma obowiązywać</label>
                <div class="datepickers">
                  <datepicker
                    :monday-first="true"
                    :language="pl"
                    v-model="userCommissionStartDate"
                    name="userCommissionStartDate"
                    :placeholder="'Wybierz datę'"
                    :disabledDates="{ to: new Date() }"
                    required
                  ></datepicker>
                </div>
              </div>
              <div class="input-container">
                <label>Do kiedy ma obowiązywać</label>
                <div class="datepickers">
                  <datepicker
                    :monday-first="true"
                    :language="pl"
                    v-model="userCommissionStopDate"
                    name="userCommissionStopDate"
                    :placeholder="'Wybierz datę'"
                    :disabledDates="{ to: new Date() }"
                    required
                  ></datepicker>
                </div>
              </div>
              <button class="buttonm btn btn-outline-dark mt-3" type="submit">
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="editCurrentCommission"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editCurrentCommission"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editCommission">
              Zmiana aktualnej prowizji
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="topform" @submit.prevent="editUserCurrentCommission()">
              <div class="input-container">
                <label>Wartość prowizji</label>
                <input
                  v-model.number="currentUserCommission"
                  id="userCommission"
                  type="number"
                  class="form-control"
                  required
                  max="1"
                  min="0"
                  placeholder="0.00"
                  step="0.01"
                />
              </div>

              <div class="input-container">
                <label>Do kiedy ma obowiązywać</label>
                <div class="datepickers">
                  <datepicker
                    :monday-first="true"
                    :language="pl"
                    v-model="currentUserCommissionDate"
                    name="currentUserCommissionDate"
                    :placeholder="'Wybierz datę'"
                    :disabledDates="{ to: new Date() }"
                    required
                  ></datepicker>
                </div>
              </div>
              <button class="buttonm btn btn-outline-dark mt-3" type="submit">
                Zapisz
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import shared from "../shared";
import { URL } from "../axios";
import TableHeader from "../components/TableHeader";
import Datepicker from "vuejs-datepicker";
import { pl } from "vuejs-datepicker/dist/locale";

export default {
  name: "UserCommisions",
  components: {
    TableHeader,
    Datepicker,
  },
  computed: {
    users() {
      return this.$store.getters.getUsersWithCommissions;
    },
  },
  created() {
    this.$store.dispatch("fetchUsersWithTheirCommisions", {
      on_page: this.users.on_page,
      page_number: this.users.page_number,
    });
    this.formattedDate = shared.formattedDate;
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.isFuture = shared.isFuture;
    this.dateWithoutTimeToString = shared.dateWithoutTimeToString;
  },
  methods: {
    setUserCommissionData(userId, commission, startDate, stopDate) {
      this.userCommission = commission;
      this.userCommissionStartDate = startDate;
      this.userCommissionStopDate = stopDate;
      this.userId = userId;
    },
    setUserCurrentCommissionData(userId, commission, date) {
      (this.currentUserCommission = commission),
        (this.userId = userId),
        (this.currentUserCommissionDate = date);
    },
    async editUserCommission() {
      if (!this.userCommissionStartDate || !this.userCommissionStopDate) {
        return this.$notify({
          group: "error",
          text: "Wybierz datę rozpoczęcia i zakończenia prowizji",
        });
      }

      if (!this.isFuture(this.userCommissionStartDate)) {
        return this.$notify({
          group: "error",
          text: "Data rozpoczęcia musi być w przyszłości",
        });
      }

      if (!this.isFuture(this.userCommissionStopDate)) {
        return this.$notify({
          group: "error",
          text: "Data zakończenia musi być w przyszłości",
        });
      }

      if (new Date(this.userCommissionStopDate) <= new Date(this.userCommissionStartDate)) {
        return this.$notify({
          group: "error",
          text: "Data zakończenia musi być późniejsza niż data rozpoczęcia",
        });
      }

      const formattedStartDate = this.dateWithoutTimeToString(this.userCommissionStartDate);
      const formattedStopDate = this.dateWithoutTimeToString(this.userCommissionStopDate);
      const url = `/api/user/periodic-commission/${this.userId}?value=${this.userCommission}&date_start=${formattedStartDate}&date_stop=${formattedStopDate}`;
      try {
        const res = await axios.post(url);
        if (res.status === 200) {
          this.$notify({
            group: "success",
            text: "Pomyslnie dodano prowizję na dany okres",
          });
        }
        this.$store.dispatch("fetchUsersWithTheirCommisions", {
          on_page: this.users.on_page,
          page_number: this.users.page_number,
          search_param: this.$route.query.search,
        });
      } catch (err) {
        console.log(err.response);
        if (err.response.status !== 403) {
          this.$notify({
            group: "error",
            text: "Nie udało się dodać prowizji",
          });
        }
      }
    },

    async editUserCurrentCommission() {
      if (!this.currentUserCommissionDate) {
        return this.$notify({
          group: "error",
          text: "Wybierz datę ważności prowizji",
        });
      }

      if (!this.isFuture(this.currentUserCommissionDate)) {
        return this.$notify({
          group: "error",
          text: "Data musi być w przyszłości",
        });
      }

      const formattedDate = this.dateWithoutTimeToString(this.currentUserCommissionDate);
      const url = `api/admin/user-commission/${this.userId}?commission=${this.currentUserCommission}&commission_valid_date=${formattedDate}`;
      try {
        const res = await axios.post(url);
        if (res.status === 200) {
          this.$notify({
            group: "success",
            text: "Pomyslnie dodano prowizję na dany okres",
          });
        }
        this.$store.dispatch("fetchUsersWithTheirCommisions", {
          on_page: this.users.on_page,
          page_number: this.users.page_number,
          search_param: this.$route.query.search,
        });
      } catch (err) {
        console.log(err.response);
        if (err.response.status !== 403) {
          this.$notify({
            group: "error",
            text: "Nie udało się dodać prowizji",
          });
        }
      }
    },
    downloadXls() {
      const url = "api/admin/user-commissions/file";
      axios(url, {
        method: "GET",
        headers: {
          "Content-Disposition": "attachment; filename=user profiles.xls",
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        responseType: "blob",
      })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", "user_commissions.xls");
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch((err) => console.log(err.response));
    },
    getUrl() {
      return URL;
    },
    fetchData() {
      this.$store.dispatch("fetchUsersWithTheirCommisions", {
        on_page: this.users.on_page,
        page_number: this.users.page_number,
        search_param: this.$route.query.search,
      });
    },
  },
  data() {
    return {
      pl: pl,
      userId: "",
      userCommission: "",
      userCommissionStartDate: "",
      userCommissionStopDate: "",
      currentUserCommission: "",
      currentUserCommissionDate: "",
      id: null,
      searchParam: "",
      sortingOptions: [
        {
          name: "first_name",
          displayName: "Imie",
        },
        {
          name: "last_name",
          displayName: "Nazwisko",
        },
        {
          name: "creation_date",
          displayName: "Data utworzenia",
        },
        {
          name: "phone",
          displayName: "Telefon",
        },
        {
          name: "pesel",
          displayName: "Pesel",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
